import axios, { AxiosRequestConfig } from "axios";
import { getLocalItem, getUserLocal, removeLocalItem } from "./helper";

export const contentType = (type) => {
    return { "Content-Type": type };
};

function reloadToLogin() {
    window.localStorage.clear();
    window.location.replace("/login");
}

function handleUnauthorized(error) {
    const authorization = error.config?.headers?.Authorization;
    if (error.response?.status === 401 && authorization?.startsWith("Bearer ")) {
        reloadToLogin();
    }
    return Promise.reject(error);
}

export const METHOD = {
    GET: "get",
    POST: "post",
    PUT: "put",
    PATCH: "patch",
    HEAD: "head",
    DELETE: "delete",
};

export const EContentType = {
    ALL:"*/*",
    JSON: "application/json",
    BINARY: "multipart/form-data",
    TEXT: "plain/text",
    URLENCODED: "application/x-www-form-urlencoded",
    UTF8:"text/html; charset=utf-8"
};

export const API_ENDPOINT_URL = process.env.REACT_APP_SRVLESS_HOST + `/api`

const userLocal = getLocalItem("key");


const API = axios.create({
    baseURL: API_ENDPOINT_URL,
    headers: { Accept: EContentType.JSON, ...contentType(EContentType.JSON)},
    withCredentials: true,
});

API.interceptors.response.use((response) => response, handleUnauthorized);
axios.interceptors.response.use((response) => response, handleUnauthorized);

function execApi(method, url, data={}, params="", headers={}) {
    return API.request({
        method: method,
        url: url,
        data: data,
        params: params,
        headers: headers,
    })
        .then((response) => {
            console.log("Axios response==>", response);
            return response;
        })
        .catch((error) => {
            console.log("Axios error====>", error);
            return error
        });
}

export function api(method, url, data, params, headers) {
    return execApi(method, url, data, params, headers);
}
